import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function FeaturePackDiffRow({ item }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 1,
                bgcolor: item.bgcolor,
                borderBottom: "1px solid",
                borderColor: "divider",
            }}
        >
            <Iconify icon={item.icon} width={16} sx={{ color: item.color }} />
            <Typography variant="body2" sx={{ flex: 1, fontFamily: "Sometype Mono, monospace", color: item.color }}>
                {item.label}
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 700, color: item.color }}>
                {item.status}
            </Typography>
        </Box>
    )
}
